import React, { FC } from 'react'

export type Props = {
  step: number
  allSteps: number
}

export const Steps: FC<Props> = ({ step, allSteps }) => {
  return (
    <div className="CS-steps">
      Step {step} of {allSteps}
    </div>
  )
}
